import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

interface IProps {
  vendor?: string;
  // Grid cards keep the row's height so Select stays on one line whether or not the item has a vendor.
  reserveSpace?: boolean;
  icon?: React.ReactElement;
  // With a prefix the line reads as a sentence and the vendor is emphasised.
  prefix?: string;
}

const rowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  minWidth: 0,
  '& svg': { fontSize: 14, color: 'text.secondary', flexShrink: 0 },
};

const hiddenRowSx: SxProps<Theme> = { ...rowSx, visibility: 'hidden' };

const emphasisSx: SxProps<Theme> = { fontWeight: 'medium' };

const defaultIcon = <StorefrontOutlinedIcon />;

export const VendorLine: React.FC<IProps> = ({ vendor, reserveSpace = false, icon = defaultIcon, prefix }) => {
  if (!vendor && !reserveSpace) {
    return null;
  }

  const hasPrefix = !!prefix && !!vendor;

  return (
    <Box aria-hidden={!vendor} sx={vendor ? rowSx : hiddenRowSx}>
      {icon}
      <Typography variant="caption" color={hasPrefix ? 'text.primary' : 'text.secondary'} noWrap>
        {hasPrefix ? (
          <>
            {prefix}{' '}
            <Box component="span" sx={emphasisSx}>
              {vendor}
            </Box>
          </>
        ) : (
          vendor || '\u00a0'
        )}
      </Typography>
    </Box>
  );
};
